export default __webpack_public_path__ + "static/media/icon_vertical_dots_.94129901.svg";